// extracted by mini-css-extract-plugin
export default {"detallesBtn":"Detalles_detallesBtn__RSe5o"};